export default {"src":"/_next/static/media/subwallet.fb0a696e.svg","height":128,"width":85,"blurWidth":0,"blurHeight":0};